import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query';
import {API, CreateGuestWithMinDataPayload} from '@chekin/api';
import {CoreError, Guest, QUERY_CACHE_KEYS} from '@chekin/core';
import {useReservation} from '../context/reservation';
import {useIsMounted} from '@chekin/guestapp-ui-kit';

type UseMutateShortGuestProps = UseMutationOptions<
  Guest,
  CoreError,
  CreateGuestWithMinDataPayload
>;
function useMutateShortGuest({
  onError,
  onMutate,
  onSettled,
  onSuccess,
}: UseMutateShortGuestProps = {}) {
  const {reservationId} = useReservation();
  const queryClient = useQueryClient();
  const isMounted = useIsMounted();

  return useMutation<Guest, CoreError, CreateGuestWithMinDataPayload>({
    mutationFn: payload =>
      API.guest.createWithMinData({...payload, reservation_id: reservationId}),
    onSuccess: (...args) => {
      onSuccess?.(...args);
      queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.reservation],
      });
      queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.guestGroup],
      });
      queryClient.resetQueries({
        queryKey: [QUERY_CACHE_KEYS.formFields],
      });
    },
    onMutate,
    onError: (...args) => {
      if (!isMounted.current) {
        return;
      }

      onError?.(...args);
    },
    onSettled,
  });
}

export {useMutateShortGuest};
